import React from "react";

// Importing Images
import socialNet from "../assests/social_net.jpg";
import quad from "../assests/quad_1.jpg";
import linearRegression from "../assests/linear_Regression.jpg";
import deepSplit from "../assests/deepSplit.png";
import streamSense from "../assests/StreamSense.png";
import healthApp from "../assests/health-care.jpg";
import aquaPaths from "../assests/Aqua-paths.jpg";
import concept from "../assests/Concept-Logo.png";


const projects = [
    {
        title: "DeepSplit",
        image: deepSplit,
        link: "https://github.com/MssManjunath/Concept",
        tags: ["Demacus", "MinIO", "Redis"],
      },
      {
        title: "StreamSense",
        image: streamSense,
        link: "https://github.com/MssManjunath/Concept",
        tags: ["Redis", "Python", "GCP"],
      },
  {
    title: "Concept",
    image: concept,
    link: "https://github.com/MssManjunath/Concept",
    tags: ["Claude", "LangChain", "Convex"],
  },
  {
    title: "Aqua Paths",
    image: aquaPaths,
    link: "https://github.com/MssManjunath/Aqua_Paths",
    tags: ["ReactJS", "NodeJs", "MapsTier"],
  },
  {
    title: "Health Care App",
    image: healthApp,
    link: "https://github.com/MssManjunath/Health_care_App",
    tags: ["ReactNative", "NodeJs", "Expo"],
  },
//   {
//     title: "NEU-Deals",
//     image: eCommerce,
//     link: "",
//     tags: ["React", "NodeJs", "SpringBoot"],
//   },
//   {
//     title: "Chat-Bot",
//     image: chatBot,
//     link: "https://github.com/MssManjunath/Chat_Bot",
//     tags: ["Python", "NLP", "TensorFlow"],
//   },
//   {
//     title: "Social Network",
//     image: socialNet,
//     link: "https://github.com/MssManjunath/Social-Network-Site",
//     tags: ["HTML", "PHP", "MySQL"],
//   },
//   {
//     title: "Quadratic Equation Solver",
//     image: quad,
//     link: "https://github.com/MssManjunath/Quadratic-Equations",
//     tags: ["Java"],
//   },
//   {
//     title: "Live Linear Regression Demo",
//     image: linearRegression,
//     link: "https://github.com/MssManjunath/Linear-Regression-Representation-OpenGl",
//     tags: ["Java", "OpenGL"],
//   },
];

const Projects = () => {
  return (
    <div className="sec-projects-container">
      <h2 className="sec-title"></h2>
      <div className="sec-cards">
        {projects.map((project, index) => (
          <a
            key={index}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="project-card-link"
          >
            <div className="card1"> {/* Using your existing CSS class */}
              <div className="proc-image">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="proc-title">{project.title}</div>
              <div className="proc-tags-container">
                {project.tags.map((tag, idx) => (
                  <div key={idx} className="proc-tag">{tag}</div>
                ))}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Projects;
